// Invalidate `all` after any change to that entity; `list` is one page/search/sort.
// What to invalidate after a change, per the backend's dashboard queries:
//   owner created -> owners
//   owner edited  -> owners, fields (field rows show owner details)
//   owner deleted -> owners, fields, alerts (its fields and alerts go with it)
//   field changed -> fields, alerts, fieldStats, charts
//   alert changed -> alerts, fields (field rows show whether alerts are open)
//
// Panel alerts sit under `alertKeys`, so any review refreshes them for free.
// Its charts sit under `fieldStatsKeys`, so a review doesn't refetch them.
export const ownerKeys = {
  all: ["owners"],
  list: (params) => ["owners", "list", params],
  meta: (id, areaUnit) => ["owners", "meta", id, areaUnit],
};

export const fieldKeys = {
  all: ["fields"],
  list: (params) => ["fields", "list", params],
  meta: (id, areaUnit) => ["fields", "meta", id, areaUnit],
};

export const alertKeys = {
  all: ["alerts"],
  list: (params) => ["alerts", "list", params],
  field: (fieldId) => ["alerts", "field", fieldId],
};

// The field panel's two charts.
export const fieldStatsKeys = {
  all: ["field-stats"],
  stats: (fieldId) => ["field-stats", fieldId, "indices"],
  acceptability: (fieldId) => ["field-stats", fieldId, "acceptability"],
};

// The Charts page result.
export const chartKeys = {
  all: ["charts"],
  data: (params) => ["charts", params],
};
